export default {
  listForArea(context, product_id) {
    const params = { limit: 100 };
    if (product_id) params.product_id = product_id;
    const qs = new URLSearchParams(params).toString();
    return window.axios.get(`/community/?${qs}`).then(({ data }) => {
      context.commit("setCommunities", data.results);
      return data;
    });
  },

  get(context, id) {
    return window.axios.get(`/community/${id}`).then(({ data }) => {
      context.commit("setCommunity", data);
      return data;
    });
  },

  listPosts(context, { id, limit = 10, offset = 0 }) {
    const qs = new URLSearchParams({ limit, offset }).toString();
    return window.axios
      .get(`/community/${id}/posts?${qs}`)
      .then(({ data }) => data);
  },

  createPost(context, { id, text, image }) {
    const payload = { text: text || "" };
    if (image) payload.image = image;
    return window.axios
      .post(`/community/${id}/posts`, payload)
      .then(({ data }) => data);
  },

  listForums(context, id) {
    const qs = new URLSearchParams({ limit: 100 }).toString();
    return window.axios
      .get(`/community/${id}/forums?${qs}`)
      .then(({ data }) => data);
  },

  getForum(context, forumId) {
    return window.axios
      .get(`/community/forums/${forumId}`)
      .then(({ data }) => data);
  },

  listForumPosts(context, { forumId, limit = 10, offset = 0 }) {
    const qs = new URLSearchParams({ limit, offset }).toString();
    return window.axios
      .get(`/community/forums/${forumId}/posts?${qs}`)
      .then(({ data }) => data);
  },

  createForumPost(context, { forumId, text, image }) {
    const payload = { text: text || "" };
    if (image) payload.image = image;
    return window.axios
      .post(`/community/forums/${forumId}/posts`, payload)
      .then(({ data }) => data);
  },

  editPost(context, { postId, text, image }) {
    const payload = {};
    if (text !== undefined) payload.text = text;
    if (image !== undefined) payload.image = image;
    return window.axios
      .patch(`/community/posts/${postId}`, payload)
      .then(({ data }) => data);
  },

  deletePost(context, postId) {
    return window.axios.delete(`/community/posts/${postId}`);
  },

  createProducerPost(
    context,
    { id, text, image, publish_at, is_pinned, moderator_profile_code }
  ) {
    const payload = { text: text || "" };
    if (image) payload.image = image;
    if (publish_at) payload.publish_at = publish_at;
    if (is_pinned !== undefined) payload.is_pinned = is_pinned;
    if (moderator_profile_code)
      payload.moderator_profile_code = moderator_profile_code;
    return window.axios
      .post(`/community/manage/communities/${id}/posts`, payload)
      .then(({ data }) => data);
  },

  editProducerPost(
    context,
    { postId, text, image, publish_at, is_pinned, moderator_profile_code }
  ) {
    const payload = {};
    if (text !== undefined) payload.text = text;
    if (image !== undefined) payload.image = image;
    if (publish_at !== undefined) payload.publish_at = publish_at;
    if (is_pinned !== undefined) payload.is_pinned = is_pinned;
    if (moderator_profile_code !== undefined)
      payload.moderator_profile_code = moderator_profile_code;
    return window.axios
      .patch(`/community/manage/posts/${postId}`, payload)
      .then(({ data }) => data);
  },

  cancelPost(context, postId) {
    return window.axios.delete(`/community/manage/posts/${postId}`);
  },

  listModeratorProfiles(context, productId) {
    const id = productId || context.rootState.setup.product_id;
    const qs = new URLSearchParams({ limit: 100 }).toString();
    return window.axios
      .get(`/comments/moderators/${id}?${qs}`)
      .then(({ data }) => (data && data.results ? data.results : data || []));
  },

  createModeratorProfile(context, { name, photo, product_id }) {
    const payload = {
      name,
      product_id: product_id || context.rootState.setup.product_id
    };
    if (photo) payload.photo = photo;
    return window.axios
      .post("/comments/moderators/", payload)
      .then(({ data }) => data);
  },

  like(context, postId) {
    return window.axios
      .post(`/community/posts/${postId}/like`)
      .then(({ data }) => data);
  },

  likeComment(context, commentId) {
    return window.axios
      .post(`/community/comments/${commentId}/like`)
      .then(({ data }) => data);
  },

  listComments(context, { postId, limit = 10, offset = 0 }) {
    const qs = new URLSearchParams({ limit, offset }).toString();
    return window.axios
      .get(`/community/posts/${postId}/comments?${qs}`)
      .then(({ data }) => data);
  },

  comment(context, { postId, text, parent_id }) {
    const payload = { text };
    if (parent_id) payload.parent_id = parent_id;
    return window.axios
      .post(`/community/posts/${postId}/comments`, payload)
      .then(({ data }) => data);
  },

  editComment(context, { commentId, text }) {
    return window.axios
      .patch(`/community/comments/${commentId}`, { text })
      .then(({ data }) => data);
  },

  deleteComment(context, commentId) {
    return window.axios.delete(`/community/comments/${commentId}`);
  },

  unreadCount(context, id) {
    return window.axios
      .get(`/community/${id}/notifications/unread-count`)
      .then(({ data }) => {
        context.commit("setUnreadCount", data.unread_count);
        return data;
      });
  },

  listNotifications(context, { id, limit = 20, offset = 0 }) {
    const qs = new URLSearchParams({ limit, offset }).toString();
    return window.axios
      .get(`/community/${id}/notifications?${qs}`)
      .then(({ data }) => data);
  },

  markRead(context, { id, ids }) {
    const payload = ids && ids.length ? { ids } : {};
    return window.axios
      .post(`/community/${id}/notifications/mark-read`, payload)
      .then(({ data }) => {
        context.dispatch("unreadCount", id);
        return data;
      });
  }
};
